import mycoinsBot from "../../config/mycoinsBot";

const firebaseConfig = {
  apiKey: "AIzaSyCoFDOkhjykR9Vg1LkveyuvG3YF-yG8VJ8",
  authDomain: "mycon-bot.firebaseapp.com",
  projectId: "mycon-bot",
  storageBucket: "mycon-bot.firebasestorage.app",
  messagingSenderId: "202875895217",
  appId: "1:202875895217:web:7ca26bca480d3471931190",
  measurementId: "G-XV49G5D6Z6",
};

const generalCopys = {
  catalogo_integral:
    "Você paga o <b>valor total</b> da parcela durante o contrato do seu consórcio e aproveita as vantagens da menor taxa do mercado.",
  catalogo_pagametade:
    "Você paga <b>apenas 50% do valor da parcela até contemplar.</b> Depois, o valor que foi reduzido será diluído e somado nas parcelas restantes.",
  catalogo_reduzida:
    "Você tem a parcela <b>reduzida em 30% até contemplar.</b> Depois, a diferença será diluída nas parcelas restantes.",
  anti_fraude: {
    button: "Falar com um especialista",
    bubble:
      "Para seguir com a escolha da forma de pagamento da primeira parcela e efetivar a contratação da sua cota, clique no botão abaixo para confirmar o seu cadastro com um de nossos especialistas.",
  },
};

const fireBaseDefaults = {
  welcome_message: "Welcome",
  datadog_sample_rate: 5,
  datadog_trace_rate: 100,
  general_copys_prod: generalCopys,
  general_copys_dev: generalCopys,
  mycoins_dev: {
    ...mycoinsBot[0],
  },
  mycoins_prod: {
    ...mycoinsBot[0],
  },
  seguro_prestamista_prod: false,
  isMonthlyFees_dev: false,
  isMonthlyFees_prod: false,
};

export { fireBaseDefaults, firebaseConfig };
